// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LoginForm from '../components/LoginForm';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
`;

const Login = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (username, password) => {
    if (username === 'admin' && password === 'n30B0t1qc-v31LL3') {
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/dashboard');
    } else {
      setError('Identifiants invalides');
    }
  };

  return (
    <LoginContainer>
      <LoginForm onSubmit={handleSubmit} error={error} />
    </LoginContainer>
  );
};

export default Login;